module.exports = __webpack_public_path__ + "static/media/slider1-1.006cb653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/slider1-1.jpg
// module id = 475
// module chunks = 0